import { AcceptedFileType, PhotoUploadError } from './types';

const ACCEPTED_TYPES: AcceptedFileType[] = ['image/jpeg', 'image/png', 'image/webp'];
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

export const validateImage = (
  file: File,
  maxSize: number = MAX_FILE_SIZE
): PhotoUploadError | null => {
  // Check file type
  if (!ACCEPTED_TYPES.includes(file.type as AcceptedFileType)) {
    return {
      code: 'invalid_type',
      message: 'Please upload a JPG, PNG, or WebP image'
    };
  }

  // Check file size
  if (file.size > maxSize) {
    return {
      code: 'file_too_large',
      message: `File size must be less than ${Math.round(maxSize / (1024 * 1024))}MB`
    };
  }

  return null;
};